import type { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { getPageBackground, type PageId } from '@/config/backgroundConfig'
import { staggerContainer, cardItem, useMotionVariants } from '../motion/motionTokens'

interface PageShellProps {
  pageId: PageId
  title: string
  subtitle?: string
  icon?: ReactNode
  /** Override the page's static background (e.g. the club hero by level) */
  backgroundImage?: string
  children: ReactNode
}

export function PageShell({ pageId, title, subtitle, icon, backgroundImage, children }: PageShellProps) {
  const bg = getPageBackground(pageId)
  const image = backgroundImage ?? bg.image

  return (
    <div className="page-shell">
      {/* Background image */}
      <div
        className="page-shell-bg"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      {/* Dark overlay with color tint */}
      <div
        className="page-shell-bg"
        style={{
          background: bg.overlayGradient,
        }}
      />
      <motion.div
        className="page-shell-content"
        variants={useMotionVariants(staggerContainer)}
        initial="initial"
        animate="enter"
      >
        <motion.div className="page-shell-header" variants={cardItem}>
          <h1 className="page-shell-title">
            {icon}
            {title}
          </h1>
          {subtitle && <p className="page-shell-subtitle">{subtitle}</p>}
        </motion.div>
        <motion.div variants={cardItem}>
          {children}
        </motion.div>
      </motion.div>
    </div>
  )
}
